import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { routes } from 'routes';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ path }) => {
   const user = useSelector((s) => s.auth.user);
   if (user) {
      if (path === routes.catalogConsent) {
         return <Outlet />;
      }
      if (!user.consentApprovedAt) {
         return <Navigate to={routes.catalogConsent} />;
      }
      return <Outlet />;
   }

   return <Navigate to={routes.signIn} />;
};

export default PrivateRoute;
